const attach = (element) => {
    const url = document.URL
    const convertToID = string => string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s/g, '').toLowerCase()
    let fixPhpStatements = ''
    let fixPhpStatement = []

    const anchors = element.querySelectorAll('.box-content legend')
    const boxes = element.querySelectorAll('.box')
    const anchorNav = document.querySelector('.anchor-list')
    const anchorNavList = document.querySelector('.anchor-list ul')
    const chartStats = element.querySelector('.chart-stats')
    const anchorStaticticsHeading = document.querySelector('.anchor-list-chart')
    const anchorListActions = document.querySelector('.anchor-list-actions')
    const formActionsButtons = document.querySelectorAll('.form-actions input')
    const formActions = document.querySelector('.form-actions')
    const editHeight = document.querySelector('#snippet--content').offsetHeight
    const windowHeight = window.innerHeight

    if(windowHeight > editHeight + 100) {
        anchorNavList.classList.add('is-withoutHover')
    }

    formActionsButtons.forEach(input => {
        if(input.getAttribute('name') === '_submit' || input.getAttribute('name') === 'submit') {
            anchorListActions.innerHTML = anchorListActions.innerHTML +'<button class="btn btn-primary">Uložit a zpět</button>'
        } else if(input.getAttribute('name') === 'submit_and_stay' || input.getAttribute('name') === 'submit_stay') {
            anchorListActions.innerHTML = anchorListActions.innerHTML +'<button class="btn btn-primary">Uložit</button>'
        } else if(input.getAttribute('name') === 'submit_wait') {
            anchorListActions.innerHTML = anchorListActions.innerHTML +'<button class="btn btn-primary">Poslat ke schválení</button>'
        } else if(input.getAttribute('name') === 'submit_yes') {
            anchorListActions.innerHTML = anchorListActions.innerHTML +'<button class="btn btn-primary">Schválit</button>'
        } else if(input.getAttribute('name') === 'submit_no') {
            anchorListActions.innerHTML = anchorListActions.innerHTML +'<button class="btn btn-primary">Zamítnout</button>'
        }
    })

    const anchorActionsButtons = document.querySelectorAll('.anchor-list-actions button')

    anchorActionsButtons.forEach(button => {
        button.addEventListener('click', () => {
            formActionsButtons.forEach(input => {
                if(input.getAttribute('name') === '_submit') {
                    if(button.textContent === 'Uložit a zpět'){
                        input.click()
                    }
                } else if (input.getAttribute('name') === 'submit_and_stay') {
                    if(button.textContent === 'Uložit') {
                        input.click()
                    }
                } else if (input.getAttribute('name') === 'submit_wait') {
                    if(button.textContent === 'Poslat ke schválení') {
                        input.click()
                    }
                } else if (input.getAttribute('name') === 'submit_yes') {
                    if(button.textContent === 'Schválit') {
                        input.click()
                    }
                } else if (input.getAttribute('name') === 'submit_no') {
                    if(button.textContent === 'Zamítnout') {
                        input.click()
                    }
                }
            })
        })
    })

    if(url.includes('/edit') && !url.includes('opening-hours/edit') && !url.includes('navigation/edit') && !url.includes('documents/edit') && !url.includes('segments/edit') || url.includes('/maintenance')) {
        if(chartStats) {
            anchorStaticticsHeading.classList.add('is-showing')
        }

        boxes.forEach(box => box.classList.add('is-nav-visible'))

        anchors.forEach(anchor => {
            let convertedID = convertToID(anchor.textContent)
            if(!fixPhpStatement.includes(anchor.textContent)) {
                anchor.setAttribute('id', convertedID)
                if(convertedID.includes('oteviracidoba')) {
                    anchorNavList.innerHTML = anchorNavList.innerHTML + `<li><a href="#${convertedID}"><span class="anchor-list-arrow"></span>Otevírací doba</a></li>`
                } else if (convertedID.includes('dokumentykestazeni')) {
                    anchorNavList.innerHTML = anchorNavList.innerHTML + `<li><a href="#${convertedID}"><span class="anchor-list-arrow"></span>Dokumenty ke stažení</a></li>`
                } else if (convertedID.includes('800x540')) {
                    anchorNavList.innerHTML = anchorNavList.innerHTML + `<li><a href="#${convertedID}"><span class="anchor-list-arrow"></span>Obrázek</a></li>`
                } else if (convertedID.includes('oddelujtecarkou')) {
                    anchorNavList.innerHTML = anchorNavList.innerHTML + `<li><a href="#${convertedID}"><span class="anchor-list-arrow"></span>Odeslat e-mail na zkoušku</a></li>`
                } else {
                    anchorNavList.innerHTML = anchorNavList.innerHTML + `<li><a href="#${convertedID}"><span class="anchor-list-arrow"></span>${anchor.textContent}</a></li>`
                }
            }
            fixPhpStatement.push(anchor.textContent)
          })

          anchorNav.style.visibility = 'visible'

          anchorNavList.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault()
                const linkId = link.getAttribute('href').substring(1);
                if(windowHeight < editHeight + 100) {
                    document.querySelector(`legend[id="${linkId}"]`).scrollIntoView()
                }
                })
            })
    } else {
        anchorNav.style.display = 'none'
        formActions?.classList.add('is-shown')
    }
}

document.querySelectorAll('.anchor-watcher').forEach(attach)
